import { render } from "./NewReferralFacilityForm.vue?vue&type=template&id=f754a682&scoped=true"
import script from "./NewReferralFacilityForm.vue?vue&type=script&lang=js"
export * from "./NewReferralFacilityForm.vue?vue&type=script&lang=js"

import "./NewReferralFacilityForm.vue?vue&type=style&index=0&id=f754a682&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f754a682"]])

export default __exports__